import React from 'react';
import { Check } from 'lucide-react'; 
import { Link } from 'react-router-dom'; 

export default function Tuotteet() {
  return (
      <section id="plans" className="py-10 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Ajankohtaiset tuotteet ja palvelut</h2>
            <p className="text-slate-600 text-lg">Räätälöimme palvelut asiakkaittemme tarpeita vastaaviksi kokonaisuuksiksi, jotta voimme varmistua palveluiden saumattoman yhteensopivuuden. Näitä palveluita kysytään juuri nyt:</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center max-w-6xl mx-auto">
            {[
              {
                title: "Colocation 10U",
                type: "Palvelinsalipalvelut",
                features: ["10U colocation palvelinkaappi", "Oma lukittu palvelinkaappi", "1 Gbit/s verkkoyhteys", "1 * 16A sähkönsyöttö"],
                price: "120 €/kk"
              },
              {
                title: "Colocation 20U",
                type: "Palvelinsalipalvelut",
                features: ["20U colocation palvelinkaappi", "Oma lukittu palvelinkaappi", "1 Gbit/s verkkoyhteys", "2 * 16A sähkönsyöttö"],
                price: "240 €/kk"
              },
              {
                title: "Colocation 42U",
                type: "Palvelinsalipalvelut",
                features: ["42U colocation palvelinkaappi", "Oma lukittu palvelinkaappi", "1 Gbit/s verkkoyhteys", "2 * 32A sähkönsyöttö"],
                price: "Kysy tarjous"
              },
              {
                title: "Colocation server 1U",
                type: "Palvelinsali-paikka yhdelle palvelimelle",
                features: ["1U palvelinsalitila", "250 W virransyöttö", "1 Gbit/s verkkoyhteys", "Laajennettavissa lisäpalveluilla, esim. vpn-yhteydet"],
                price: "60 €/kk"
              },
              {
                title: "Private Cloud 2 TB",
                type: "Private Cloud",
                features: ["2 TB Storage", "784 GB RAM", "Yksityiset resurssit", "Täysin tuettu"],
                price: "Kysy tarjous"
              },
              {
                title: "Private Cloud 10 TB",
                type: "Private Cloud",
                features: ["10 TB Storage", "784-7840 GB RAM", "Yksityiset resurssit", "Täysin tuettu"],
                price: "Kysy tarjous"
              }
            ].map((plan, idx) => (
              <div key={idx} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="text-blue-600 font-semibold text-sm mb-2 uppercase tracking-wider">{plan.type}</div>
                <h3 className="text-2xl font-bold text-slate-900 mb-6">{plan.title}</h3>
                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3 text-slate-600">
                      <Check className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="text-lg font-semibold text-slate-900 mb-6">
                  Hinta alkaen: <span className="text-blue-600">{plan.price}</span>
                </div>
                <Link to="/contact" className="w-full py-4 px-6 bg-white border-2 border-slate-200 text-slate-900 rounded-xl font-bold hover:border-blue-600 hover:text-blue-600 transition-colors">Tarjouspyyntö</Link>
              </div>
            ))}
          </div>
        </div>
      </section>
  );
}
